import './generic_avatar_view.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.TwitterAvatarView extends Monitoring.Views.GenericAvatarView

  initialize:(options) ->
    @social_content_type = ''
    if options.user
      @avatar = options.user.avatar()
      @social_network_id = options.user.social_network_id()
      @social_content_type = 'twitter'
    else
      @avatar = options.socialContent.avatar()
      @social_network_id = options.socialContent.userId()
      @social_content_type = options.socialContent.type()

  render: =>
    super
    @$el.find(".avatar").one('error', @_fetchFromProfile)

  _fetchFromProfile:(event) =>
    $(event.target).one('error', @_setDefaultAvatar)
    _social_network_id = encodeURIComponent(@social_network_id)
    $.ajax
      type: 'GET'
      url: "/profiles/api/twitter/#{_social_network_id}/avatar_url"
      success: (response) =>
        if response.success
          $(event.target).attr('src', response.avatar_url)
        else
          @_setDefaultAvatar(event)
      error: =>
        showError('An unexpected error has ocurred. Please contact us if this error persists.')


  _setDefaultAvatar:(event) =>
    $(event.target).attr('src', window.image_path("default_profile.png"))
    @_setUpdateJob()

  _setUpdateJob: ->
    $.ajax
      type: 'POST'
      url: "/profiles/api/twitter/#{@social_network_id}/avatar_url"


#  _reloadTwitterAvatar: (event) =>
#    $.ajax
#      type: 'GET'
#      url: "/profiles/api/twitter/#{@social_network_id}/avatar_url"
#      success: (response) =>
#        if response.success
#          avatar_url = response.avatar_url
#        else
#          avatar_url = '/assets/default_profile.png'
#        $(event.target).attr('src', avatar_url)
#      error: =>
#        showError("An unexpected error has occurred. Please contact us if this error persists.")